import {Card, Flex, Typography} from 'antd';
import React from 'react';
import {useCSContext} from 'Context/ContentStackContext';
import PropTypes from 'prop-types';

const {Title, Text} = Typography;

const NoSearchResults = ({CSTexts}) => {
  const {artifacts} = useCSContext();

  return (
    <Card style={{marginBottom: 48, marginTop: 32}}>
      <Flex vertical align="center" gap={8} style={{padding: '32px 48px'}}>
        <img src={artifacts.no_result_image} alt="" />
        <Title level={5} style={{margin: 0}}>
          {CSTexts.heading}
        </Title>
        <Text style={{textAlign: 'center'}}>{CSTexts.description}</Text>
      </Flex>
    </Card>
  );
};

NoSearchResults.propTypes = {
  CSTexts: PropTypes.object.isRequired,
};

export default NoSearchResults;
